$(document).ready(function(){
  $("#nav-open").click(function() {
    if ($("#nav-open").hasClass("toggled")) {
      $("#nav-open").removeClass("toggled")
      sidenavOpen()
    } else {
      $("#nav-open").addClass("toggled")
      sidenavClose()
    }
  })
  $('.tooltipped').tooltip()
})

const sidenavOpen = () => {
  document.getElementById("side-area").style.width = "230px"
  document.getElementById("sidenav").style.width = "230px"
}

const sidenavClose = () => {
  document.getElementById("side-area").style.width = "60px"
  document.getElementById("sidenav").style.width = "60px"
}
